module.exports = __webpack_public_path__ + "img/Blow out services 2.svg";